import { NotificationGroup, UnreadCountByGroup } from "types/Notification";
import {
  DECREMENT_UNREAD_COUNT,
  INCREMENT_UNREAD_COUNT,
  SET_UNREAD_COUNT_BY_GROUP,
  STARTUP_NOTIFICATION,
} from "constant/notification.constant";

export function startupNotification() {
  return {
    type: STARTUP_NOTIFICATION,
  };
}

export function setUnreadCountByGroup(counts: UnreadCountByGroup) {
  return {
    type: SET_UNREAD_COUNT_BY_GROUP,
    payload: counts,
  };
}

export function decrementUnreadCount(group: NotificationGroup) {
  return {
    type: DECREMENT_UNREAD_COUNT,
    payload: group,
  };
}

export function incrementUnreadCount(group: NotificationGroup) {
  return {
    type: INCREMENT_UNREAD_COUNT,
    payload: group,
  };
}
